import React, { PureComponent } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { checkAuthStatus } from '../../store/authentication/thunks';
import { MAIN_PATH } from '../AppRoutes';
import { State } from '../../store/state';

type RouteProps = {
  isAuthenticated: boolean;
  component: any;
  checkAuthStatus: () => boolean;
  location?: any;
  path: string;
};

/**
 * A state aware route component that will only permit navigation to the route if the user is authenticated, otherwise
 * redirecting them to the main/login path.
 */
class ProtectedRoute extends PureComponent<RouteProps> {
  render() {
    const { component: Component, ...rest } = this.props;

    const render = () =>
      this.props.checkAuthStatus() ? (
        <Component />
      ) : (
        /* TODO `state` in store? */
        <Redirect push to={{ pathname: MAIN_PATH }} />
      );

    return <Route {...rest} render={render} />;
  }
}

const mapStateToProps = (state: State) => ({
  isAuthenticated: state.authentication.isAuthenticated,
});

const mapDispatchToProps = {
  checkAuthStatus,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProtectedRoute);
